export const fileAdvices = [
  { 
    id: 1, 
    title: "Make a to-do list", 
    text: `To-do list can help you visualize scope of work you have do to, so you can 
      better manage time needed for each task.`
  },
  { 
    id: 2, 
    title: "Don't switch context", 
    text: `If you often switch your attention from one thing to another you need 
      more time to get back into previous topic. So avoid splitting your attention.`
  },
  { 
    id: 3, 
    title: "Get rid of notifications", 
    text: `Before you start work you can turn off notifications on smartphone or laptop. 
      That will keep you more concentrated on current task.`
  }
]